import { useEffect } from 'react';

const Spotify = () => {
    useEffect(() => {
        window.location.href = 'https://spotify.aranish.uk';
    }, []);

    return null;
};

export default Spotify;
